import { render, staticRenderFns } from "./contactDir_c.vue?vue&type=template&id=4c8c77dc"
import script from "./contactDir_c.vue?vue&type=script&lang=js"
export * from "./contactDir_c.vue?vue&type=script&lang=js"
import style0 from "./contactDir_c.vue?vue&type=style&index=0&id=4c8c77dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports